module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-001a"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n"
  }, [_c('span', [_vm._v("2")])]), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCIETY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REPARED FOR"), _c('br')]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPULATION?")])])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("They will still bear fruit in old age, they will stay fresh and green.")])]), _c('p', {
    staticClass: "auteur"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM 92:14")])])])]), _c('div', {
    staticClass: "chapeau"
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "image",
      "id": "sep_4",
      "src": "images/sep.jpg"
    }
  })])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("H")]), _vm._v("ow did an increase in the population of elderly in our society come about, and why? Who or what is responsible for our increasingly aging population? Is it due to the skills of physicians, advances made by scientists or is it part of God’s providential plan? For America’s largest generation, some 70 million plus born approximately between 1946 and 1964, increases in life do not necessarily mean the dreamed-for retirement. But could longer life open up divine opportunities for the intervention of a wise God? Is society prepared? Is the modern church ready for the aging tidal wave that is hitting the beaches of America’s communities?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("These issues are underscored by the 2009-2010 health care debate in the United States. As an example of misinformation, physicians on the till by large pharmaceutical companies have presented false information before Congress, and the media is quick to present anecdotal cures for Alzheimer’s disease. So misled, many in Congress, thinking we will have a cure for the dreaded disease in the next three to five years, have failed to address the needs of millions of family caregivers whose work is largely unrecognized and unappreciated but absolutely ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("essential to the nation’s welfare.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-001",
      "id": "ap_antb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to the Institute of Medicine, starting in 2011, a baby boomer will turn sixty-five every twenty seconds."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-002",
      "id": "ap_antb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The United States Social Security Administration expects to receive ten thousand applications per day for the next twenty years just for members of the baby boomer generation who are reaching ages of entitlement. Because of increasing longevity, most Western cultures have moved from a three-generational family structure to a four-generational one. Older people live longer and nuclear families have fewer children, meaning that kinship relationships are less among siblings and more across generations. Social scientists describe this new societal structure as the "), _c('i', [_vm._v("beanpole family")]), _vm._v(", in which both parents work full time, divorce is more prevalent, and fewer daughters and sons are available to honor and care for parents as they age."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-003",
      "id": "ap_antb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" This is a major concern for the United States; for the first time, those over age sixty-five now outnumber those age eighteen and younger. And most modern nations are in the same boat.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "aniv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Challenges Associated with an Aging Population ")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As our senior population increases, we face a variety of challenges associated with this unprecedented growth. Centenarians represent the fastest growing age group in our country. In this century, some people are expected to reach 120 years, generally considered by scientists to be the maximum age for human beings. Surveys and experts indicate that most people, when asked, underestimate their longevity and therefore fail to plan adequately for it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-004",
      "id": "ap_antb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" As an example, many older Americans are "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("uncomfortable talking about their own death, even though death is an undeniable reality. The church should be addressing the fears of death more completely, so that people might prepare for it emotionally, spiritually and financially. When asked what people fear the most about death, they register concerns about extended pain and suffering, loss of control and the afterlife.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-005",
      "id": "ap_antb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Most older people die from chronic diseases like congestive heart failure or cancer. Many suffer unnecessarily at the end of life from symptoms like nausea or pain, because their physician, family and pastor fail to recommend in a timely way hospice"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-006",
      "id": "ap_antb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" and palliative care programs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-007",
      "id": "ap_antb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Both these initiatives, aimed at alleviating these fears, remain largely underutilized."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-008",
      "id": "ap_antb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In America, the old-age poverty rate is about the same as that among non-elderly. However, the experiences of older women differ significantly from men economically, often because of life course issues related to household duties, career interruptions, limited pensions, lower wages and social security benefits, caregiving duties, higher rates of widowhood and other factors. Women represent the majority of our fastest growing age group, the oldest old, and they form one of the poorest groups in our society."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-009",
      "id": "ap_antb-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Almost 40 percent of African American and Latina women age eighty-five and older are living below the federal poverty level."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-010",
      "id": "ap_antb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Marriage often protects women against experiencing poverty in old age. Given these factors, let us consider the biblical "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("mandates to care for widows beside the fact that non-married women account for 56 percent of those aged eighty or above, and most of these are widows as defined by Paul in 1 Timothy 5. Many widows are in poverty because of gender inequities in social security, divorce or a husband’s failure to provide a pension.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-011",
      "id": "ap_antb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" In Mark 12 and Matthew 23, the teachings of Christ to religious leaders are clear regarding widows.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These tremendous gains in life expectancy are not being greeted with optimism by many within our society, but are instead being received with tales of impending doom, grounded in depressing realities like the rising cost of medical care for the elderly. At present, elder caregiving is largely a woman’s challenge and issue. The typical caregiver is a forty-seven-year old woman who works outside the home and spends more that twenty hours per week providing unpaid care to her mother. Now that American mothers and daughters, the traditional caregivers for older persons, are more involved in the full-time labor force than in any other nation in the world (68 percent of mothers work full time), they are less available to care for the growing number of older loved ones."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-012",
      "id": "ap_antb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" When working women are required to provide such care, they are often burdened by juggling outside work and combinations of child care and eldercare.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the United States alone there are approximately 34 million family caregivers at any point in time, and the estimated economic cost to American families (e.g., lost revenue, direct costs associated with transportation, shopping, bathing, feeding, contacting agencies) has been estimated at $350 billion dollars, equivalent to the entire gross sales from Wal-Mart. Or spent by Medicare ($342 billion) and Medicaid ($300 billion) in 2005."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-013",
      "id": "ap_antb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" The cost to the workplace and working caregivers is tremendous. Thirty-seven percent of caregivers report quitting their job or reducing work hours. Unfortunately, our work with congregations suggests that the church is doing little to support the needs of caregivers in their congregations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-014",
      "id": "ap_antb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Western culture, communities, families and congregations face incredible financial challenges related to our aging populations. Who will pay for national and state entitlement programs to support this pool of seniors? Spending on Medicare and Medicaid represents almost 25 percent of the federal budget,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-015",
      "id": "ap_antb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" and these costs are growing at a rate that far exceeds the economic growth rate of the United States. Sadly, older people and their caregivers pay a larger portion of the incomes on health care services than they did before Medicare and Medicaid were created in 1965, and those below the poverty line pay almost 30 percent of their total income on health care."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-016",
      "id": "ap_antb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The vulnerabilities of Medicare Trust Fund are estimated to be greater than those to Social Security."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-017",
      "id": "ap_antb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Current debates about health care in the United States have not properly addressed these issues. According to recent estimates from the MetLife Mature Market Institute and other research groups, the current costs of long-term care (for example, aging-in-place facilities, nursing homes, assisted living and dementia care units) will test the savings plans of even the very rich."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-018",
      "id": "ap_antb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Though some congregations have gotten involved in developing affordable aging-in-place facilities that allow a person to move from independent housing to assisted living to nursing home status to cognitive-care units, this is much more the exception for most communities. Most older Americans prefer to avoid nursing homes altogether, but new resident-centered paradigms of care are emerging, and congregations and denominations need to be more involved."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-019",
      "id": "ap_antb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("How are families (the primary caregivers of older Americans), governmental agencies and other societal systems in the United States going to meet the current and expanding need for services to seniors without the help of congregations? Given the shortages of geriatric professionals in the majority of communities, how can congregations help? What role, if any, does the church play—and what role should it play—in these challenges?")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "aniv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("The Church’s Response ")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("The church must be a visible, key shareholder in the aging of America, yet many of its structures and programs are outdated. Most programs of senior ministry, much like the United States’ Social Security and Medicare Programs, were developed during the nineteenth and twentieth centuries and were based on the foundational premise of a relatively short life span and health care system designed for acute and not chronic medical care. Now that life expectancy is much longer, the vast majority of church programs are grossly obsolete like many of the United States’ national programs and policies. Churches are generally thought of as institutions that neglect the training of their leaders, particularly in gerontology, and professional organizations therefore discount the church as a positive change agent in society. But churches stand to benefit—both in effectiveness and in impact—by becoming more involved on a local level with professional organizations that focus on aging well; learning to partner with other congregations to share in the financial costs of innovative, effective programs that promote lifestyle changes associated with successful aging; and offering countercultural programs that value the role of older people.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("We think caregiving will be the great test of character this century, and yet the modern church is virtually mute on the topic. Almost half of those eighty-five and older, one of our fastest growing age groups, face the probability of dementia (about two-thirds will be diagnosed with the dreaded Alzheimer’s disease). Recipients of such a diagnosis are virtually guaranteed years of dependency on others. Traditionally, ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("families have provided most late-life care. According to our research, very few churches provide systematic help to familial caregivers, and when such a program is offered, those who manage it often feel overwhelmed, unprepared and underresourced.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-020",
      "id": "ap_antb-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Community-based, ecumenical partnerships will become a necessity. Employed adult children or elderly spouses are often unable to provide all the help needed. If elder care is the number one human resource problem in most organizations, why wouldn’t it be the case for the church? Some churches are literally aging to death; actually, they already have for the most part in Western Europe.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The church provides little if any planning for late life. At present, if a woman in the United States lives to sixty-five years of age, she can expect to live, on average, another nineteen years, five of which will be years of dependency. Many widows suffer financially without the church’s knowledge or intervention. For men, life expectancy after sixty-five is approximately fifteen years, with three anticipated years of dependency. The church has an obligation to become part of the solution for these new aging challenges.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Profound shortages exist in the geriatric care work force. Take for example the number of geriatric certified (trained) physicians in the United States: there are approximately eight thousand, but only about one thousand practice exclusively with older persons. United States medical schools combined have only five specifically geriatric medicine departments; the balance is absorbed in other divisions of medicine (internal medicine, family practice). In contrast, Japan, Great Britain and Canada have separate departments of geriatric medicine in most of their medical schools. In the United States, the number of medical students selecting primary-care vocations (family practice, internal medicine) is decreasing. As noted earlier, our systems of care remain focused on acute, not chronic, care, and many primary care doctors are not choosing geriatrics because they will make more money in other specialties. As professional groups address this problem, the church also should be helping church members locate trained professionals; em"), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("ploying geriatric care managers (geriatric-trained nurses and social workers) to help congregates navigate the long-term care system; and insisting that seminaries provide geriatric and gerontological training to its future pastors.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Without adequate resources for mobility, many seniors face isolation, depression and poor health, and society faces increased costs of care and a loss of the vital contributions of older generations. The first step toward improving this situation comes through gaining insight into the issues and creating a vision for change in which the church is a clear stakeholder. The church can help identify and target at-risk groups and provide interventions and training. For example, spinal and hip fractures resulting from falls are epidemic among the elderly, and the church easily could offer a variety of fall prevention programs.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-021",
      "id": "ap_antb-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Medical and legal professionals in the United States are ill equipped to address the coming age wave associated with the baby boomer generation. The first boomers have already qualified for social security. In past years, one worker in five contributed to social security; now, one in two workers contributes to the funding of entitlement programs like Medicare and Social Security. Law schools across the United States affiliate with only a paucity of elder law clinics. Notably, the Hartford Foundation has attempted to support the gerontological training of physicians, social workers and nurses, but its efforts are not sufficient to meet the growing need.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Preliminary research suggests that similarly only a few seminaries offer an elective course on aging and ministry, though all pastors will have older persons in their congregations. Those clergy inclined to blame or ignore the elderly may know little about them. Only a very small number of seminaries offer solid accredited courses on the implications of a graying church for ministry. As early as 1988, Hutchinson estimated that only twenty seminaries offered pastoral courses on an age-related topic."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-022",
      "id": "ap_antb-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" He also reported that in 1985 fifty seminary profes"), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("sors and deans gathered to consider what courses should be taught and how they could encourage and stimulate the seminaries to teach gerontological insights in theology. Hutchinson further reported that the Institute on Religious Life and the AARP office published a substantial document, “Aging Society—A Challenge to Theological Education.” Twenty-four scholars in eight disciplines prepared stimulating material suggesting a theological basis for seminaries to consider (and simultaneously provide) courses in the church and aging field. Though these leaders hoped that gerontological insights would someday pervade the entire seminary curriculum, Watkins provided a more recent but similarly bleak view of seminaries and the availability of such courses.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-023",
      "id": "ap_antb-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" J. L. Knapp and J. Elder also confirmed these patterns of neglect by seminaries in their research, which indicates that some seminaries have added a course focusing on the needs and concerns of older adults, but gerontological content remains a minor consideration among the vast majority of seminaries."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-024",
      "id": "ap_antb-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Only a few seminaries consider these courses basic to the theological education of prospective ministers and therefore require them for graduation. Occasionally they are incorporated in courses on pastoral theology. In our research, we could not locate one American seminary that has conducted a comprehensive review of its curricula to insure that it is “geriatrically enriched” and truly reflective of our aging congregations and population. Education in pastoral ministry lacks what the John A. Hartford Foundation and the Gerontological Society of America does for schools of medicine, social work and nursing. These organizations have provided substantial funding and research to examine the overall curricula offered in the colleges of these three professions. When we have approached seminaries, they have shown little inclination to apply for grants that might provide for such an intense review and overhaul of their curricula. For the church to lag behind such secular programs removes the church from its proper position of leadership "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("in addressing the pressing agendas regarding older persons. Such issues—many even moral in nature—are not completely addressed without a Christian perspective.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("We believe that the church is obligated to act as a countercultural, biblically based advocate on critical matters with regard to aging. Churches can and should promote the care and employment of seniors, healthy caregiving practices, caregiving support, late-life planning, aging-in-place initiatives and strategies for successful aging, and they should uphold the inherent value of dependent, disabled people. Many churches are “aging to death” because they are unable to attract younger members, and rather than taking an intergenerational perspective that would connect the younger members with more elderly members, some national denominations have dramatically cut their programs for seniors in favor of youth ministries.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("A growing number of pastors are asking for help. Some have simply aged out of youth ministry. Some feel overwhelmed and burdened by their aging congregations and lack a clear sense of direction in solving the mounting challenges with their senior members. During one presentation I (Dr. Parker) gave to a large gathering of ministers to seniors, a majority of the audience reported feeling frustrated at not having received specific training in how to minister to seniors; indeed, many of them felt more like modern day travel agents than ministers-to-seniors. Encouragingly, many had received personal callings to minister to their older members and were hungry for new and effective strategies that would assist them in that ministry.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#antb-025",
      "id": "ap_antb-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Boomers with frail, dependent parents are also frantically seeking advice for understanding and coping with America’s long-term care system. The needs of their parents can erupt in periodic crises or stretch on for several years. Such crises can thrust a church member into a bureaucratic maze of trying to make successive care arrangements in a "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("badly fragmented long-term care system. The nation’s patchwork of nursing homes, foster homes, adult day centers and home health care agencies offer a dizzying array of often unsatisfactory options for the church and society. It is imperative that the church step up and offer guidance and assistance to its caregiving and senior members.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("People in the church are beginning to see their need with regard to elder care issues, and we think there are reasons to be hopeful that the church is on the precipice of an exciting impact on our culture. Facing up to the ways society’s admiration of youth diminishes our churches is a first step in reenvisioning the role of seniors in the church today.")])])])])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 78
// module chunks = 0